// Dependencies
import React from 'react';

import { Heading, Link, Text } from '@nerdwallet/currency';

export default [
  {
    id: 'initial',
    label: {
      content: (
        <Text small>
          We’ll use the answers you give us to show you which home improvement
          financing solution works best.
        </Text>
      ),
    },
    cta: {
      header: <Heading level="3">Recommended lenders</Heading>,
      content: (
        <Text>
          We’ll use the answers you give us to recommend lenders for your needs
        </Text>
      ),
    },
  },
  {
    id: 'badCreditScore',
    label: {
      header: <Heading level="5">Bad credit score</Heading>,
      content: (
        <Text small>
          Consider building your credit score. While you may be able to finance
          your home improvement with a personal loan, you’ll benefit from lower
          interest rates if you elevate your credit score. Get personalized tips
          and access to helpful tools from NerdWallet to help you build your
          credit. Check your{' '}
          <Link
            target="_blank"
            href="https://www.nerdwallet.com/home/dashboard/credit-score"
          >
            credit score
          </Link>{' '}
          to get started.
        </Text>
      ),
    },
    cta: {
      header: <Heading level="3">Recommended lenders</Heading>,
      content: (
        <Text>
          Consider building your credit score. You’ll benefit from lower
          interest rates if you elevate your credit score.
        </Text>
      ),
    },
  },
  {
    id: 'creditCard',
    label: {
      header: <Heading level="5">Credit card</Heading>,
      content: (
        <Text small>
          Based on your selections, you are a good candidate for a credit card
          with an introductory 0% APR. These cards are available mostly to those
          with good to excellent credit. You would be a good candidate if your
          project is $15,000 or less and you can pay off the debt within 21
          months.
        </Text>
      ),
    },
    cta: {
      header: <Heading level="3">Recommended credit card issuers</Heading>,
      content: (
        <Text>
          NerdWallet has done the homework and compiled the Best 0% and Low
          Interest Credit Cards. These cards are the best in the business, from
          waived fees to rewards and more.
        </Text>
      ),
      button: 'Get started',
      link: '/blog/top-credit-cards/nerdwallets-best-low-interest-credit-cards?trk=mortgages-home-improvement-results',
    },
  },
  {
    id: 'personalLoan',
    label: {
      header: <Heading level="5">Personal loan</Heading>,
      content: (
        <Text small>
          Based on your selections, you are a good candidate for a personal
          loan. Personal loans allow long repayment terms, usually at lower
          interest rates than credit cards. With a great credit score, you’ll
          have access to lower rates, but loans typically are available to
          people with lower scores.
        </Text>
      ),
    },
    cta: {
      header: <Heading level="3">Recommended personal loans</Heading>,
      content: (
        <Text>
          NerdWallet has done the homework and compiled home improvement
          personal loans for you. Find an offer you like and get prequalified on
          NerdWallet.
        </Text>
      ),
      button: 'Get started',
      link: '/personal-loans?loanUseFilter=HOME_IMPROVEMENT&creditScoreFilter={{0}}&loanAmountFilter={{1}}&trk=mortgages-home-improvement-results',
    },
    keys: [
      {
        key: 'inputs.creditScore',
      },
      {
        key: 'inputs.homeImprovementCost',
      },
    ],
  },
  {
    id: 'cashOutRefi',
    label: {
      header: <Heading level="5">Cash-out refinance</Heading>,
      content: (
        <Text small>
          Based on your selections, you are a good candidate for a cash-out
          refinance. A cash-out refi is a great choice when you have an
          opportunity to lower your mortgage rate and get the cash you need for
          your home improvement. Interest rates are competitive on cash-out
          refinances, but closing costs typically are higher than on home equity
          products.
        </Text>
      ),
    },
    cta: {
      header: (
        <Heading level="3">Recommended cash-out refinance lenders</Heading>
      ),
    },
  },
  {
    id: 'homeEquityLoan',
    label: {
      header: <Heading level="5">Home equity loan</Heading>,
      content: (
        <Text small>
          Based on your selections, you are a good candidate for a home equity
          loan. A home equity loan is a great choice when you have a good idea
          how much your home improvement project will cost, and want to start
          paying down principal immediately. Home equity loans typically have
          low closing costs, but they often carry slightly higher rates than a
          cash-out refinance.
        </Text>
      ),
    },
    cta: {
      header: <Heading level="3">Recommended home equity loans</Heading>,
    },
  },
  {
    id: 'heloc',
    label: {
      header: <Heading level="5">Home equity line of credit</Heading>,
      content: (
        <Text small>
          Based on your selections, you are a good candidate for a HELOC, or
          Home Equity Line of Credit. This kind of loan is a great choice when
          you’re unsure how much your home improvement project will cost,
          because it keeps you from taking a larger loan than you need. Keep in
          mind, however, that most HELOC interest rates are adjustable and will
          eventually reset.
        </Text>
      ),
    },
    cta: {
      header: <Heading level="3">Recommended HELOC lenders</Heading>,
    },
  },
];
